import React from 'react';
import cx from 'classnames';
import '../../../../ui/accordions/Accordion/index.js';
import '../../../../ui/accordions/AccordionSelect/index.js';
import '../../../../ui/badges/Badge/index.js';
import '../../../../ui/badges/BadgeIcon/index.js';
import '../../../../ui/badges/Checked/index.js';
import '../../../../ui/badges/Panel/index.js';
import '../../../../ui/badges/Status/index.js';
import '../../../../ui/badges/Tag/index.js';
import '../../../../ui/buttons/BabyButton/Base.js';
import '../../../../ui/buttons/BabyButton/variants/Chat/index.js';
import '../../../../ui/buttons/BabyButton/variants/Menu/index.js';
import '../../../../ui/buttons/BabyButton/variants/User/index.js';
import '../../../../ui/buttons/BabyButton/variants/Vip/index.js';
import '../../../../ui/buttons/BabyButton/variants/Wallet/index.js';
import '../../../../ui/buttons/Button/index.js';
import '../../../../ui/buttons/CloseButton/index.js';
import '../../../../ui/buttons/DirectionButton/index.js';
import { GradientButton } from '../../../../ui/buttons/GradientButton/index.js';
import '../../../../ui/buttons/GradientButtonV2/index.js';
import '../../../../ui/buttons/TabButton/index.js';
import '../../../../ui/buttons/TabButtonV2/index.js';
import '../../../../ui/buttons/TimerButton/index.js';
import '../../../../ui/buttons/TimerButtonV2/index.js';
import '../../../../ui/buttons/TimerButtonV3/index.js';
import '../../../../ui/loaders/Loader/index.js';
import '../../../../ui/loaders/ScreenLoader/index.js';
import '../../../../ui/modals/Modal/MobileWrapperV2/index.js';
import '../../../../ui/modals/Modal/Modal.js';
import '../../../../ui/modals/Modal/ModalContentWrapper/index.js';
import '../../../../ui/popups/Popper/index.js';
import '../../../../ui/popups/Popup/BasePopup/index.js';
import '../../../../ui/popups/Popup/Thumb/index.js';
import '../../../../ui/popups/Popup/ThumbV2/index.js';
import '../../../../ui/popups/Popup/InfoTooltip/index.js';
import '../../../../ui/sliders/EmblaCarousel/index.js';
import '../../../../ui/tables/Table/index.js';
import '../../../../ui/tables/Table/TableTd/index.js';
import '../../../../ui/tabs/Tabs/index.js';
import '../../../../ui/tabs/TabsV2/index.js';
import '../../../../ui/texts/CryptoValue/index.js';
import '../../../../ui/texts/AmountValue/index.js';
import '../../../../ui/texts/TitleWithCurrency/index.js';
import '../../../../ui/texts/Text/index.js';
import '../../../../ui/texts/TextNavigation/index.js';
import '../../../../ui/texts/MinValue/index.js';
import '../../../../ui/socials/SocialsList/index.js';
import styles from './index.module.scss.js';

const Button = ({
  onClick,
  text,
  className,
  style,
  type,
  marginTop,
  marginTopForgotPassword,
  ...props
}) => /* @__PURE__ */ React.createElement(
  GradientButton,
  {
    ...props,
    kind: "fill",
    size: "md",
    type,
    text,
    ...type === "submit" ? {} : {
      onClick
    },
    style,
    className: cx(styles.box, className, {
      [styles["margin-top"]]: marginTop,
      [styles["margin-forgot-password"]]: marginTopForgotPassword
    })
  }
);
Button.displayName = "Auth.Form.Button";

export { Button };
//# sourceMappingURL=index.js.map
